/**
 * Appearance preview iframe protocol (D51). The editor renders the draft inside a same-origin
 * iframe so landing-kit's viewport media queries see a real phone or desktop width.
 *   frame → parent  { type: READY }                 the frame mounted and wants the draft
 *   parent → frame  { type: DRAFT, area, doc, theme, catalog }
 *                   the current (possibly unsaved) store document, the Studio area to show,
 *                   and the published listings the storefront previews fill in with
 * Both sides accept only messages from their own origin and from the expected window.
 */
export const READY = 'mp:appearance-frame-ready';
export const DRAFT = 'mp:appearance-draft';

/** Is `event` a protocol message of `type` from `source` on this page's own origin? */
export function isPreviewMessage(event, { type, origin, source }) {
  if (!event || event.origin !== origin) return false;
  if (source !== undefined && event.source !== source) return false;
  return !!event.data && typeof event.data === 'object' && event.data.type === type;
}

/** Virtual viewport width the preview renders at, per device. */
export const DEVICE_WIDTH = { phone: 390, desktop: 1280 };

/** Scale that fits a `device` viewport into a `containerWidth` box (never enlarges). */
export function previewScale(device, containerWidth) {
  const w = DEVICE_WIDTH[device] || DEVICE_WIDTH.desktop;
  if (!(containerWidth > 0)) return 1;
  return Math.min(1, containerWidth / w);
}
